module.exports = __webpack_public_path__ + "img/AT0000002420717.25217d3b.png";